import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import storage from '../utils/storage'

Vue.use(VueI18n)

// 获取存储的语言，默认中文
const locale = storage.get('language') || 'zh'

const i18n = new VueI18n({
  locale: locale === 'zh' ? 'zh' : 'en',
  messages: {
    zh,
    en
  }
})

export default i18n